// src/services/cookie-updater.js
import axios from 'axios'
import useAuthStore from '@/store/authStore.js'
import apiService from '@/services/apiService'
import loadingStore from '@/store/loading'

const INTERVAL_TIME = 100000
let cookieUpdateInterval = null

async function updateCookies () {
  try {
    const REFRESH_COOKIES_ENDPOINT = process.env.VUE_APP_URL_DOMAIN + '/ajax/refresh_cookies.php'
    const meta = document.querySelector('meta[name="csrf-token"]')
    const session = meta ? meta.getAttribute('content') : ''

    const params = new URLSearchParams()
    params.append('session', session)
    params.append('userinfo', JSON.stringify(useAuthStore.getters.userInfo))
    params.append('isauth', useAuthStore.getters.isAuthenticated)
    params.append('domain', process.env.VUE_APP_URL_DOMAIN)

    const response = await axios.post(
      REFRESH_COOKIES_ENDPOINT,
      params,
      { withCredentials: true }
    )

    if (response.status === 200 && response.data.response) {
      // Rinnova autenticazione
      useAuthStore.dispatch('authenticate', response.data.userinfo)
      return
    }

    if (useAuthStore.getters.isAuthenticated && !response.data.response) {
      loadingStore.commit('setLoading', true)
      apiService.logout()
      const fanoutUrl = process.env.VUE_APP_URL_DOMAIN + '/ajax/logout-fanout.php'
      window.location.replace(fanoutUrl)
    }
    // Redirect esterno assoluto
  } catch (error) {
    console.error('Errore durante l\'aggiornamento cookie:', error)

    // ❗ Consigliato: anche in caso di errore, fai un logout pulito
    useAuthStore.dispatch('logout')
  }
}

export const startCookieUpdater = () => {
  updateCookies()
  cookieUpdateInterval = setInterval(updateCookies, INTERVAL_TIME)
}

export const stopCookieUpdater = () => {
  if (cookieUpdateInterval) {
    clearInterval(cookieUpdateInterval)
    cookieUpdateInterval = null
  }
}

export const reloadTorefres = () => {
  if (!loadingStore.isLoading) {
    loadingStore.commit('setLoading', true)
  }
  updateCookies()
  loadingStore.commit('setLoading', false)
}
